import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonViewDidLeave,
  useIonViewWillEnter,
} from '@ionic/react'
import React, { BaseSyntheticEvent, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getIntubationSelector } from '../selectors'
import { chevronBackOutline } from 'ionicons/icons'
import { ProcedureConstants } from '../../../components/procedure/store/procedure.constants'
import { IInputRow } from '../../../components/procedure/ProcedureDynamic.component'
import {
  saveIntubation,
  setAirwayComplications,
  setStyletUsed,
  setCuffFill,
  setCuffFillQty,
  setDistance,
  setDistanceUnit,
  setIndications,
  setLaryngoscopeBlade,
  setLaryngoscopicGrade,
  setMallampati,
  setMethod,
  setRSIProtocol,
  setSecuredVia,
  setSellickManeuver,
  setSize,
  setUpdateInputRows,
  setVerificationVia,
  setVerifiedBy,
  setIntubationDefatults,
  setReasonsForFailure,
  setAirwayComplicationsPNNV,
  setAirwayPlacementTechnique,
  setAirwayPlacementTechniquePNNV,
} from '../store/intubation.actions'
import { getCurrentDate, getCurrentTime, randomNumber } from '../../../utilities'
import { IntubationConstants } from '../store/intubation.constants'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import Procedure from '../../../components/procedure/Procedure.component'
import { setInputRows, setIsFirstVisit } from '../../../components/procedure/store/procedure.actions'
import { getAllPNNVOptionsSelector, getIntubationOptionsSelector } from '../../options/selectors'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { IOption } from '../../../common/common.types'
import { initialIntubationState } from '../store/intubation.reducers'
import { showAlert } from '../../../components/alert/store/alert.actions'
import { compareObjectsIfEqual, filterOutObjectKeys } from '../../../utilities/object.util'
import { setDeleteProcedure, setProcedureLoaderItem } from '../../timeline/store/timeline.actions'
import { TimelineConstants } from '../../timeline/store/timeline.constants'
import { getAgeRangeGroupId, getDefaultsForAgeRange } from '../../../utilities/procedures.util'
import { getDefaultsSelector } from '../../defaults/selectors/defaults.selector'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { goBack } from '../../../utilities/navigation.util'
import { getDatapointsConfigSelector } from '../../configurations/selectors'
import { IDataPointsConfig, IServiceConfig } from '../../configurations/store/configurations.types'
import { numberPadKeysWithDecimal } from '../../../components/numberPad/NumberPad.types'
import { IAlertState } from '../../../components/alert/store/alert.types'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'

const Intubation: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const history = useHistory()
  const intubation = useSelector(getIntubationSelector)

  const {
    date,
    time,
    assessedBy,
    successfulAttempt,
    pta,
    attempts,
    size,
    distance,
    distanceUnit,
    method,
    securedVia,
    verifiedBy,
    verificationVia,
    rSIProtocol,
    mallampati,
    sellickManeuver,
    laryngoscopicGrade,
    styletUsed,
    cuffFillQty,
    laryngoscopeBlade,
    cuffFill,
    indications,
    decisiontoManageTime,
    decisiontoManageDate,
    abandonedTime,
    abandonedDate,
    airwayComplications,
    airwayComplicationsPNNV,
    procedureComplications,
    response,
    responsePNNV,
    authorization,
    comments,
    updateInputRows,
    rolePerforming,
    rolePerformingPNNV,
    procedurePerformedByAnotherUnit,
    procedurePerformedByAnotherUnitPNNV,
    isEkgImport,
    intubationDefaults,
    reasonsForFailure,
    airwayPlacementTechnique,
    airwayPlacementTechniquePNNV,
  } = intubation
  const intubationOptions = useSelector(getIntubationOptionsSelector)
  const {
    distanceUnitOptions,
    methodOptions,
    securedViaOptions,
    verifiedByOptions,
    verificationViaOptions,
    rSIProtocolOptions,
    mallampatiOptions,
    sellickManeuverOptions,
    laryngoscopicGradeOptions,
    styletUsedOptions,
    cuffFillOptions,
    laryngoscopeBladeOptions,
    indicationsOptions,
    airwayComplicationsOptions,
    reasonsForFailureOptions,
    airwayPlacementTechniqueOptions,
  } = intubationOptions
  const { defaults } = useSelector(getDefaultsSelector)
  const { dOB, age, ageUnit } = useSelector(getPatientDemographicsSelector)
  const { isFirstVisit } = useSelector(getProcedureStateSelector)
  const { DP_AIRWAY_FAILURE }: IDataPointsConfig = useSelector(getDatapointsConfigSelector)

  const allPNNVOptions = useSelector(getAllPNNVOptionsSelector)
  const airwayComplicationsPNNVOptions = allPNNVOptions?.['eAirway.08']
  const airwayPLacementTechniquePNNVOptions = allPNNVOptions?.['eProcedures.14']
  const serviceConfigData: IServiceConfig = useSelector(getServiceConfigSelector)
  const { DISPLAY_SECONDS } = serviceConfigData
  const displaySeconds = !!DISPLAY_SECONDS

  const save = () => {
    dispatch(saveIntubation())
  }

  const sizeOnChange = (values: string[]) => {
    dispatch(setSize(values.join('')))
    save()
  }

  const distanceOnChange = (values: string[]) => {
    dispatch(setDistance(values.join('')))
    save()
  }

  const distanceUnitOnChange = (option: IOption) => {
    dispatch(setDistanceUnit(option))
    save()
  }

  const methodOnChange = (option: IOption) => {
    dispatch(setMethod(option))
    save()
  }

  const securedViaOnChange = (option: IOption) => {
    dispatch(setSecuredVia(option))
    save()
  }

  const verifiedByOnChange = (option: IOption) => {
    dispatch(setVerifiedBy(option))
    save()
  }

  const rSIProtocolOnChange = (option: IOption) => {
    dispatch(setRSIProtocol(option))
    save()
  }

  const mallampatiOnChange = (option: IOption) => {
    dispatch(setMallampati(option))
    save()
  }

  const sellickManeuverOnChange = (option: IOption) => {
    dispatch(setSellickManeuver(option))
    save()
  }

  const laryngoscopicGradeOnChange = (option: IOption) => {
    dispatch(setLaryngoscopicGrade(option))
    save()
  }

  const styletUsedOnChange = (option: IOption) => {
    dispatch(setStyletUsed(option))
    save()
  }

  const cuffFillQtyOnChange = (values: string[]) => {
    dispatch(setCuffFillQty(values.join('')))
    save()
  }

  const cuffFillOnChange = (option: IOption) => {
    dispatch(setCuffFill(option))
    save()
  }

  const laryngoscopeBladeOnChange = (option: IOption) => {
    dispatch(setLaryngoscopeBlade(option))
    save()
  }

  const dateTimeValidationCheck = () => {
    if (!date || !time) {
      dispatch(showAlert({ header: '', message: 'Date / Time is required' }))
      return false
    }
    return true
  }

  const initialStateCheck = () => {
    if (pta && ((date && time) || (!date && !time))) return true
    const fieldsToFilter = ['key', 'addToTimeline', 'updateInputRows', 'method', 'intubationDefaults']
    const currentState = filterOutObjectKeys(intubation, fieldsToFilter)
    const initalState = filterOutObjectKeys(initialIntubationState, fieldsToFilter)
    if (!compareObjectsIfEqual(currentState, initalState)) {
      return dateTimeValidationCheck()
    }
    return true
  }

  const onSaveClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (!pta && (!date || !time)) {
      dateTimeValidationCheck()
      return
    }
    const dateTimeValidationCheckResult = initialStateCheck()
    if (dateTimeValidationCheckResult) {
      history.push(TabConstants.TIMELINE_TAB)
    }
  }

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()

    if ((!date || !time) && !pta) {
      const alert: IAlertState = {
        message: t('common.saveTimelineEntry'),
        buttons: [
          {
            text: t('common.buttons.Yes'),
            handler: () => {
              const date = getCurrentDate()
              let time = getCurrentTime()
              if (!displaySeconds) {
                time = time.replace(/(:\d+)(:\d+)$/, '$1:00')
              }

              dispatch({ type: 'intubation/SET_TIME', time: time })
              dispatch({ type: 'intubation/SET_DATE', date: date })
              save()
              goBack()
            },
          },
          {
            text: t('common.buttons.No'),
            role: 'destructive',
            handler: () => {
              const itemToRemove = {
                key: intubation.key,
                rowActionType: TimelineConstants.SET_INTUBATION_PROCEDURE_ITEM,
              }
              dispatch(setDeleteProcedure(true))
              dispatch({ type: TimelineConstants.DELETE_TIMELINE_ITEM, payload: itemToRemove })
              goBack()
            },
          },
        ],
      }
      dispatch(showAlert(alert))
      dispatch(setProcedureLoaderItem(false))
    } else {
      const dateTimeValidationCheck = initialStateCheck()
      if (dateTimeValidationCheck) {
        goBack()
      }
      dispatch(setProcedureLoaderItem(false))
    }
  }
  const mergedAirwayComplicationsOptions = useMemo(() => {
    const baseOptions = [...(airwayComplicationsOptions ?? [])]
    const pnnvOptions = [...(airwayComplicationsPNNVOptions ?? [])]

    if (!pnnvOptions.length) {
      return baseOptions
    }

    const mergedMap = new Map<IOption['id'], IOption>()

    baseOptions.forEach((option) => {
      mergedMap.set(option.id, option)
    })

    pnnvOptions.forEach((option) => {
      const existingOption = mergedMap.get(option.id)
      if (existingOption) {
        mergedMap.set(option.id, { ...existingOption, ...option })
      } else {
        mergedMap.set(option.id, option)
      }
    })

    return Array.from(mergedMap.values())
  }, [airwayComplicationsOptions, airwayComplicationsPNNVOptions])

  const mergedAirwayPlacementTechniqueOptions = useMemo(() => {
    const baseOptions = [...(airwayPlacementTechniqueOptions ?? [])]
    const pnnvOptions = [...(airwayPLacementTechniquePNNVOptions ?? [])]

    if (!pnnvOptions.length) {
      return baseOptions
    }

    const mergedMap = new Map<IOption['id'], IOption>()

    baseOptions.forEach((option) => {
      mergedMap.set(option.id, option)
    })

    pnnvOptions.forEach((option) => {
      const existingOption = mergedMap.get(option.id)
      if (existingOption) {
        mergedMap.set(option.id, { ...existingOption, ...option })
      } else {
        mergedMap.set(option.id, option)
      }
    })

    return Array.from(mergedMap.values())
  }, [airwayPlacementTechniqueOptions, airwayPLacementTechniquePNNVOptions])

  const inputRows: Array<IInputRow> = [
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_SIZE,
          type: ProcedureConstants.NUMBER_PAD,
          hidden: false,
          props: {
            label: t('intubation.size'),
            dataTestId: 'Size',
            elementId: 'Size',
            onNumPadClick: sizeOnChange,
            values: size.split(''),
            validCharacters: numberPadKeysWithDecimal,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_DISTANCE,
          type: ProcedureConstants.NUMBER_PAD,
          hidden: false,
          props: {
            label: t('intubation.distance'),
            dataTestId: 'Distance',
            elementId: 'Distance',
            values: distance.split(''),
            onNumPadClick: distanceOnChange,
          },
        },
        {
          key: IntubationConstants.SET_DISTANCE_UNIT,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.distanceUnit'),
            dataTestID: 'DistanceUnit',
            options: distanceUnitOptions,
            action: distanceUnitOnChange,
            listHeader: 'Distance Unit',
            selectedOption: distanceUnit,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_METHOD,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.method'),
            dataTestID: 'Method',
            options: methodOptions,
            action: methodOnChange,
            listHeader: 'Method',
            selectedOption: method,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_SECURED_VIA,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.securedVia'),
            dataTestID: 'SecuredVia',
            options: securedViaOptions,
            action: securedViaOnChange,
            listHeader: 'Secured Via',
            selectedOption: securedVia,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_VERIFIED_BY,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.verifiedBy'),
            dataTestID: 'VerifiedBy',
            options: verifiedByOptions,
            action: verifiedByOnChange,
            listHeader: 'Verified By',
            selectedOption: verifiedBy,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_VERIFICATION_VIA,
          type: ProcedureConstants.MULTI_SELECT,
          hidden: false,
          props: {
            label: t('intubation.verificationVia'),
            dataTestID: 'Verification Via',
            options: verificationViaOptions,
            action: setVerificationVia,
            listHeader: 'VerificationVia',
            savedValues: verificationVia,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_AIRWAY_PLACEMENT_TECHNIQUE,
          type: ProcedureConstants.MULTI_SELECT,
          hidden: false,
          props: {
            dataTestID: 'AirwayPlacementTechnique',
            label: t('intubation.airwayPlacementTechnique'),
            options: mergedAirwayPlacementTechniqueOptions,
            action: setAirwayPlacementTechnique,
            listHeader: 'Airway Placement Techniques',
            savedValues: airwayPlacementTechnique,
            pnnvAction: setAirwayPlacementTechniquePNNV,
            savedPNNVValue: airwayPlacementTechniquePNNV,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_RSI_PROTOCOL,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.rSIProtocol'),
            dataTestID: 'RSIProtocol',
            options: rSIProtocolOptions,
            action: rSIProtocolOnChange,
            listHeader: 'RSI Protocol',
            selectedOption: rSIProtocol,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_MALLAMPATI,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.mallampati'),
            dataTestID: 'Mallampati',
            options: mallampatiOptions,
            action: mallampatiOnChange,
            listHeader: 'Mallampati',
            selectedOption: mallampati,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_SELLICK_MANEUVER,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.sellickManeuver'),
            dataTestID: 'Sellick Maneuver',
            options: sellickManeuverOptions,
            action: sellickManeuverOnChange,
            listHeader: 'Sellick Maneuver',
            selectedOption: sellickManeuver,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_LARYNGOSCOPIC_GRADE,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.laryngoscopicGrade'),
            dataTestID: 'Laryngoscopic Grade',
            options: laryngoscopicGradeOptions,
            action: laryngoscopicGradeOnChange,
            listHeader: 'Laryngoscopic Grade',
            selectedOption: laryngoscopicGrade,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_STYLET_USED,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.styletUsed'),
            dataTestID: 'Stylet Used',
            options: styletUsedOptions,
            action: styletUsedOnChange,
            listHeader: 'Stylet Used',
            selectedOption: styletUsed,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_CUFF_FILL,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.cuffFill'),
            dataTestID: 'Cuff Fill',
            options: cuffFillOptions,
            action: cuffFillOnChange,
            listHeader: 'Cuff Fill',
            selectedOption: cuffFill,
          },
        },
        {
          key: IntubationConstants.SET_CUFF_FILL_QTY,
          type: ProcedureConstants.NUMBER_PAD,
          hidden: false,
          props: {
            label: t('intubation.cuffFillQty'),
            dataTestId: 'CuffFillQty',
            elementId: 'CuffFillQty',
            values: cuffFillQty.split(''),
            onNumPadClick: cuffFillQtyOnChange,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_LARYNGOSCOPE_BLADE,
          type: ProcedureConstants.SINGLE_SELECT,
          hidden: false,
          props: {
            label: t('intubation.laryngoscopeBlade'),
            dataTestID: 'Laryngoscope Blade',
            options: laryngoscopeBladeOptions,
            action: laryngoscopeBladeOnChange,
            listHeader: 'Laryngoscope Blade',
            selectedOption: laryngoscopeBlade,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_INDICATIONS,
          type: ProcedureConstants.MULTI_SELECT,
          hidden: false,
          props: {
            dataTestID: 'Indications',
            label: t('intubation.indications'),
            options: indicationsOptions,
            action: setIndications,
            listHeader: 'Indications',
            savedValues: indications,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_DECISION_TO_MANAGE_DATE_TIME,
          type: ProcedureConstants.TIMES_ROW,
          hidden: false,
          props: {
            elementId: 'DecisiontoManage',
            header: t('intubation.decisiontoManage'),
            time: decisiontoManageTime,
            date: decisiontoManageDate,
            timeAction: IntubationConstants.SET_DECISION_TO_MANAGE_TIME,
            dateAction: IntubationConstants.SET_DECISION_TO_MANAGE_DATE,
            currentDateTimeAction: IntubationConstants.SET_DECISION_TO_MANAGE_DATE_TIME,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_ABANDONED_DATE_TIME,
          type: ProcedureConstants.TIMES_ROW,
          hidden: false,
          props: {
            elementId: 'Abandoned',
            header: t('intubation.abandoned'),
            time: abandonedTime,
            date: abandonedDate,
            timeAction: IntubationConstants.SET_ABANDONED_TIME,
            dateAction: IntubationConstants.SET_ABANDONED_DATE,
            currentDateTimeAction: IntubationConstants.SET_ABANDONED_DATE_TIME,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_AIRWAY_COMPLICATIONS,
          type: ProcedureConstants.MULTI_SELECT,
          hidden: false,
          props: {
            dataTestID: 'AirwayComplications',
            label: t('intubation.airwayComplications'),
            options: mergedAirwayComplicationsOptions,
            action: setAirwayComplications,
            listHeader: 'Airway Complications',
            savedValues: airwayComplications,
            pnnvAction: setAirwayComplicationsPNNV,
            savedPNNVValue: airwayComplicationsPNNV,
          },
        },
      ],
    },
    {
      key: randomNumber().toString(),
      inputs: [
        {
          key: IntubationConstants.SET_REASONS_FOR_FAILURE,
          type: ProcedureConstants.MULTI_SELECT,
          hidden: !DP_AIRWAY_FAILURE || successfulAttempt,
          props: {
            label: t('intubation.ReasonsForFailure'),
            dataTestID: 'ReasonsForFailure',
            options: reasonsForFailureOptions,
            action: setReasonsForFailure,
            listHeader: t('airway.ReasonsForFailure'),
            savedValues: reasonsForFailure || [],
          },
        },
      ],
    },
  ]

  const setMethodDefault = () => {
    const methodDefault = methodOptions.find(
      (option) => option.name?.replaceAll(' / ', '/') === intubationDefaults?.defaultAction
    )

    if (methodDefault) {
      dispatch(setMethod(methodDefault))
      return
    }

    dispatch(setUpdateInputRows(true))
  }

  const setFieldDefaults = () => {
    const fieldDefaults = intubationDefaults?.defaults.filter(
      (field) => field.actionId === method?.name?.replaceAll(' / ', '/')
    )

    fieldDefaults?.forEach((fieldDefault) => {
      const fieldName = fieldDefault.fieldName
      const defaultValue = fieldDefault.defaultValue

      // Size
      if (fieldName === 'field1') {
        dispatch(setSize(defaultValue || ''))
      }

      // Distance (CM at Lips)
      else if (fieldName === 'field2') {
        dispatch(setDistance(defaultValue || ''))
      }

      // RSI Protocol
      else if (fieldName === 'field5') {
        const rSIProtocolOption = rSIProtocolOptions.find((option) => option.name === defaultValue)
        dispatch(setRSIProtocol(rSIProtocolOption || null))
      }
    })

    dispatch(setUpdateInputRows(true))
  }

  useIonViewWillEnter(() => {
    const ageRange = getAgeRangeGroupId(dOB, age, ageUnit)
    const defaultsForAgeRange = getDefaultsForAgeRange(defaults, 'Intubation', ageRange)

    if (defaultsForAgeRange) dispatch(setIntubationDefatults(defaultsForAgeRange))
    else dispatch(setUpdateInputRows(true))
  }, [defaults, dOB, age, ageUnit])

  useEffect(() => {
    if (!isFirstVisit || !intubationDefaults || method) return

    setMethodDefault()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intubationDefaults])

  useEffect(() => {
    if (!isFirstVisit || !intubationDefaults || !method) return

    setFieldDefaults()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [method, intubationDefaults])

  useIonViewDidLeave(() => {
    dispatch(setIsFirstVisit(false))
  })

  if (updateInputRows) {
    dispatch(setInputRows(inputRows))
    dispatch(setUpdateInputRows(false))
  }

  return (
    <IonPage id='IntubationPage'>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' fill='clear' onClick={onBackClick} color='primary-alt'>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton data-testid='Save' fill='clear' onClick={onSaveClick} color='primary-alt'>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
          <IonTitle>Intubation</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen color='light'>
        <Procedure
          type={'intubation'}
          procedureDate={date}
          procedureTime={time}
          assessedBy={assessedBy}
          successfulAttempt={successfulAttempt}
          procedureComplications={procedureComplications}
          response={response}
          responsePNNV={responsePNNV}
          authorization={authorization}
          comments={comments}
          attempts={attempts}
          rolePerforming={rolePerforming}
          rolePerformingPNNV={rolePerformingPNNV}
          procedurePerformedByAnotherUnit={procedurePerformedByAnotherUnit}
          procedurePerformedByAnotherUnitPNNV={procedurePerformedByAnotherUnitPNNV}
          pta={pta}
          isEkgImport={isEkgImport}
        />
      </IonContent>
    </IonPage>
  )
}

export default Intubation
